import React, { useState, useEffect, useContext } from "react";
import BannerSection from "../../inc/BannerSection";
import Banner from "../../images/banner.jpg";
import TherapistSidebar from "../../inc/TherapistSidebar";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import BankImage from "../../images/bank1.svg";
import { Image } from "react-bootstrap";
import { FaAlignLeft } from "react-icons/fa";
import ApiService from "../../../utility/services/ApiService";
import { AuthContext } from "../../../utility/services/AuthContext";
import ConstConfig from "../../../utility/configs/constConfig";
import Functions from "../../../utility/services/Functions";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const TherapistBankDetails = () => {
  // LOGICAL VRIABLES

  const { setLoading } = useContext(AuthContext);
  const { check_therapist_stripe_ac_status, create_stripe_account } =
    ApiService();
  const { consoleService } = Functions();

  const [filterHideShow, setfilterHideShow] = useState(false);
  const [connectionChecked, setConnectionChecked] = useState(false);

  const navigate = useNavigate();

  // DATA VARIABLES

  const [acc_conntection, setAcc_connections] = useState(false);

  // USE EFFECTS

  useEffect(() => {
    fetch_initial_details();
  }, []);

  // FUNCTIONS

  async function fetch_initial_details() {
    setLoading(true);
    try {
      const res = await check_therapist_stripe_ac_status();
      if (res.status === 1) {
        if (res.data.account_status) {
          setLoading(false);
          navigate("/therapistbankconnected", { replace: true });
        } else {
          setAcc_connections(res.data.account_status);
          setLoading(false);
        }
        setConnectionChecked(true);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in fetch_initial_details", err);
    }
  }

  async function createStripeAccount() {
    setLoading(true);
    try {
      const res = await create_stripe_account();
      if (res.status === 1) {
        setTimeout(() => {
          setLoading(false);
        }, 6000);

        window.location.replace(res.data);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in createStripeAccount function", err);
    }
  }

  const sideBarHide = () => {
    setfilterHideShow(!filterHideShow);
  };
  return (
    <>
      <div className="breadHidePhone">
        <BannerSection banner={Banner} name={"Home"} title={"Bank Details"} />
      </div>
      {connectionChecked && !acc_conntection && (
        <React.Fragment>
          <section className="py-5 useraccount bg-light_dash">
            <div className="container">
              <div className="row">
                <div
                  className={`col-xl-3 col-md-4 ${
                    filterHideShow ? "leftShow" : "leftHide"
                  }`}
                >
                  <TherapistSidebar />
                </div>
                <div className="col-xl-9 col-md-8 fulltabBox">
                  <div className="filterBox">
                    <Link className="filterIcon" onClick={sideBarHide}>
                      <FaAlignLeft />
                    </Link>
                  </div>
                  <div className="dashboard-widg-bar d-block">
                    <div className="dashboard_body">
                      <h4 className="mb-4 ft-medium">Bank Details</h4>
                      <div className="bankBox">
                        <Image src={BankImage} alt="" className="stripe_img" />

                        <div className="under_bank_box">
                          <h2>Connect With Stripe Now</h2>

                          <Button
                            onClick={() => {
                              createStripeAccount();
                            }}
                            className="btn btn-primary me-3"
                            // style={{ backgroundColor: "#1D7E7C" }}
                          >
                            Connect
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </React.Fragment>
      )}
    </>
  );
};

export default TherapistBankDetails;
